import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const myDocumentsShowDocument = atom({
  key: "myDocumentsShowDocument",
  default: false,
  effects_UNSTABLE: [ocPersistAtom],
});
